import { render, staticRenderFns } from "./userMenu.vue?vue&type=template&id=11219f04"
import script from "./userMenu.vue?vue&type=script&lang=js"
export * from "./userMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports